enum PropelloCustomerStatusEnum {
  notFound = 'NotFound',
  deleted = 'Deleted',
  active = 'Active',
}

export default PropelloCustomerStatusEnum
